import types from '../actions/types';

import {
    paginatedResultReducer,
    initialState
} from './common/paginated_results';
import {
    singleResultReducer,
    singleResultInitialState
} from './common/single-result';
import {
    removeItem
} from './common/remove-item';


const initial_state = {
    promoCodes: initialState,
    promoCode: singleResultInitialState
}

export default function(state = initial_state, action) {
    switch (action.type) {
        case types.DELETE_PROMO_CODE.SUCCESS:

            return {
                ...state,
                promoCodes: {
                    ...state.promoCodes,
                    items: removeItem(state.promoCodes.items, action.payload.id)
                }
            };
        default:
            return {
                ...state,
                promoCode: singleResultReducer(state.promoCode, types.ADMIN_LOAD_PROMO_CODE, action),
                promoCodes: paginatedResultReducer(state.promoCodes, types.ADMIN_LOAD_PROMO_CODES, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/promo-codes.js